module.exports = __webpack_public_path__ + "static/img/02.856069d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/docs/01/02.jpg
// module id = uAUz
// module chunks = 1